import { createSlice } from "@reduxjs/toolkit";

const initialState= {
    adminmenu: null,
}

const adminMenuSlice = createSlice({
    name: "adminmenu",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
         .addCase('LOGOUT', (state) => {
            Object.assign(state, initialState);
         })
    },
    reducers:{
        storeAdminMenu: (state, action) => {
            state.adminmenu= action.payload;
        },
        addAdminMenuToStore: (state, action) => {
            state.adminmenu= [...state.adminmenu, action.payload];
        },
        editAdminMenuToStore: (state, action) => {
            state.adminmenu= state.adminmenu.map((item)=>{
                if(action.payload && action.payload.id === item.id){
                    return action.payload;
                }else{
                    return item;
                }
            });;
        },
        toggleAdminMenuInStore: (state, action) => {
            state.adminmenu= state.adminmenu.map((item)=>{
                if(action.payload && action.payload.data && action.payload.data.indexOf(item.id)<0){
                    return item;
                }else{
                    let obj= {...item};
                    obj.active= action.payload.flag===0 ? true : false;
                    return obj
                }
            });
        },
        deleteAdminMenuFromStore: (state, action) => {
            state.adminmenu= state.adminmenu.filter(item => action.payload && action.payload.indexOf(item.id) < 0);
        }
    }
})

export const { storeAdminMenu, addAdminMenuToStore, editAdminMenuToStore, toggleAdminMenuInStore, deleteAdminMenuFromStore } = adminMenuSlice.actions
export default adminMenuSlice.reducer